module.exports = __webpack_public_path__ + "img/young-m1h.e56f6d5f.png";